<template>
  <div>
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="rich-text-editor__buttons">
        <button type="button" class="rich-text-editor__button rich-text-editor__button--bold" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
          bold
        </button>
        <button type="button" class="rich-text-editor__button rich-text-editor__button--ul" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
          ul
        </button>
      </div>
    </editor-menu-bar>
    <editor-content :editor="editor" class="a-form-control rich-text-editor__input" />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import { BulletList, Bold, History, ListItem, HardBreak } from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      editor: new Editor({
        extensions: [new BulletList(), new ListItem(), new Bold(), new History(), new HardBreak()],
        content: this.value,
        onUpdate: ({ getHTML }) => {
          this.$emit('input', getHTML())
        }
      })
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>
<style lang="scss">
.rich-text-editor {
  &__buttons {
    margin-bottom: -2px;
  }

  &__button {
    appearance: none;
    background: transparent;
    border: 2px solid #c9c9c9;
    color: transparent;
    cursor: pointer;
    font: 0/0 a;
    height: 44px;
    margin-right: -2px;
    padding: 0;
    text-shadow: none;
    transition: background-color 0.25s ease;
    white-space: nowrap;
    width: 44px;

    &--bold {
      background: url(~@/assets/bold.svg) no-repeat center center;
      background-size: 50%;
    }

    &--ul {
      background: url(~@/assets/ul.svg) no-repeat center center;
      background-size: 50%;
    }

    &:hover {
      background-color: rgba(#c9c9c9, 0.15);
    }

    &.is-active {
      background-color: rgba(#c9c9c9, 0.5);
    }
  }

  &__input {
    border-top-left-radius: 0px;
    height: auto;
    min-height: 100px;

    div[contenteditable='true'] {
      min-height: 100px - 20px;
      outline: none;

      li {
        p {
          display: inline-block;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
